import {
	ID_USER_ID_KEY,
	ID_TOKEN_KEY,
	ID_REFRESH_TOKEN_KEY,
} from '@/core/constants/LSKeys';
import CryptoJS from 'crypto-js';
import { CRYPTO_KEY } from '../constants/SecretKeys';

/**
 * @description get token form localStorage
 */
export const getToken = (): string | null => {
	return window.localStorage.getItem(ID_TOKEN_KEY);
};

export const getUserId = (): string | null => {
	return window.localStorage.getItem(ID_USER_ID_KEY);
};

export const getRefreshToken = (): string | null => {
	const decryptedRefreshToken =
		window.localStorage.getItem(ID_REFRESH_TOKEN_KEY);

	if (
		decryptedRefreshToken == null ||
		decryptedRefreshToken == undefined ||
		decryptedRefreshToken == ''
	)
		return null;

	const bytes = CryptoJS.AES.decrypt(decryptedRefreshToken, CRYPTO_KEY);

	return bytes.toString(CryptoJS.enc.Utf8);
};

/**
 * @description save token into localStorage
 * @param token: string
 */
export const saveToken = (
	token: string,
	refreshToken: string,
	userId?: number
): void => {
	window.localStorage.setItem(ID_TOKEN_KEY, token);
	window.localStorage.setItem(
		ID_REFRESH_TOKEN_KEY,
		CryptoJS.AES.encrypt(refreshToken, CRYPTO_KEY).toString()
	);

	if (userId != null) {
		window.localStorage.setItem(ID_USER_ID_KEY, userId.toString());
	}
};

/**
 * @description remove token form localStorage
 */
export const destroyToken = (): void => {
	window.localStorage.removeItem(ID_TOKEN_KEY);
	window.localStorage.removeItem(ID_REFRESH_TOKEN_KEY);
	window.localStorage.removeItem(ID_USER_ID_KEY);
};

export default {
	getToken,
	getUserId,
	saveToken,
	getRefreshToken,
	destroyToken,
};
